import { useTravelataApiService } from '@/shared/composables/useTravelataApiService';
import { useTravelataAppConfig } from '@/shared/composables/useTravelataAppConfig';
import { adaptHotels } from './adapter';
import type { ApiFindHotelsResponse, HotelFound } from './types';

export interface FindHotelsParams {
  hotels: number[];
  country: number;
  term?: string;
}

function buildFindHotelsUrl(base: string, params: FindHotelsParams): string {
  const query = new URLSearchParams();
  params.hotels.forEach((id) => query.append('hotels[]', String(id)));
  query.append('term', params.term ?? '');
  query.append('country', String(params.country));
  const separator = base.includes('?') ? '&' : '?';
  return `${base}${separator}${query.toString()}`;
}

export async function findHotels(params: FindHotelsParams): Promise<HotelFound[]> {
  if (!params.hotels.length) {
    return [];
  }

  try {
    const apiService = useTravelataApiService();
    const config = useTravelataAppConfig();
    const url = buildFindHotelsUrl(`${config.gatewayUrl}${config.getHotels}`, params);

    const response = await apiService.get<ApiFindHotelsResponse>(url);

    const data = response?.data;
    if (response?.success !== true || !Array.isArray(data)) {
      return [];
    }

    return adaptHotels(data);
  } catch {
    return [];
  }
}
